import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetEnrolledCourses } from "../../../Actions/CourseA";
import EnrolledCourseInfo from "../../EnrolledCourses/Component/EnrolledCourseInfo/EnrolledCourseInfo";
import NoDataResponse from "../../../Components/NoDataResponse";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import UserPaymentAdded from "./UserPaymentsAdded";

const SettingSubscriptions = ({ pageType, setActiveTab, UserId }) => {
  const Dispatch = useDispatch();
  const { Authenticated } = useSelector((Store) => Store.LoginSignupReducer);
  const { EnrolledCourses, loading } = useSelector((Store) => Store.CourseReducer);

  console.log("EnrolledCourses are:",EnrolledCourses)
  useEffect(() => {
    if (Authenticated)
        Dispatch(GetEnrolledCourses())
    }, [Dispatch, Authenticated])

  return (
    <div className="w-full flex flex-col justify-center items-center gap-[10px]">
      <div className="w-[90%] hidden lg:flex flex-start">
        <p className="text-[#404040] text-[20px] font-bold">Subscription</p>
      </div>
        <div className="w-[90%] flex flex-col gap-[10px] lg:bg-[#F8FAFA] rounded-[9px] lg:px-[15px] lg:py-[15px]">
            {
                !loading ?
                    <div className={`flex flex-col ${
                    pageType === "settings" ? "w-[100%]" : "w-[100%] lg:w-11/12"
                    } 2xl:w-4/5`}>
                        {
                            EnrolledCourses?.length > 0 ?
                                EnrolledCourses?.map((Course) =>
                                    <EnrolledCourseInfo key={Course.EnrollmentId} Course={Course} type="settings" />)

                                : <NoDataResponse topText="You are not enrolled in any courses." />
                        }
                    </div>
                    : <LoadingSpinner Height="screen" Width="screen" Position="fixed" Top="20" Bg="white" />
            }
        </div>
        <UserPaymentAdded UserId={UserId} />
        <div className="w-[90%] flex justify-end gap-[20px] mt-[20px]">
        {/* <button
            className="w-[285px] h-[40px] rounded-[8px] bg-[#FFFFFF] text-[#A1A3EF] text-[18px]"
            style={{border:"2px solid #A1A3EF"}}
            onClick={handleUpdate}
          >
           Back
        </button> */}
        <button
            className="w-[250px] h-[40px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[18px]"
            onClick={() => setActiveTab("Payment Method")}
          >
           Add Payment Method
        </button>
        </div>
    </div>
  );
};

export default SettingSubscriptions;
